import { useCallback } from 'react';
import React, { useState } from 'react';
import FHGTextField from '../../components/TextField';
import ModalDialog from '../../fhg/components/dialog/ModalDialog';
import useEditData from '../../fhg/components/edit/useEditData';

/**
 * Component to edit a single pipe diameter.
 *
 * @param pipeDiameterValue The pipe diameter to edit.
 * @param onSubmit Submit the changes to the pipe diameter.
 * @param onClose Close the edit dialog.
 * @return {JSX.Element}
 * @constructor
 */
export default function PipeDiameterEdit({ pipeDiameterValue, onSubmit, onClose }) {

   const [editValues, handleChange, { isChanged, getValue, defaultValues }] = useEditData(pipeDiameterValue);

   /**
    * Handle numeric input with max 2 decimal places
    */
   const handleDecimalChange = useCallback((event) => {
      const value = event.target.value;
      // Allow empty string, digits, and up to 2 decimals
      if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
         handleChange(event);
      }
   }, [handleChange]);

   /**
    * Submit the changes to the pipe diameter.
    */
   const handleSubmit = useCallback((event) => {

      if (event) {
         event.preventDefault();
         event.stopPropagation();
      }

      if (isChanged) {
         onSubmit && onSubmit({ ...defaultValues, ...editValues });
      }
   }, [editValues, defaultValues, isChanged, onSubmit]);

   return (
      <ModalDialog open={true} titleKey={'operator.pipeDiameterEdit.title'} onSubmit={(event) => handleSubmit(event)} maxWidth={'sm'}
         fullWidth onClose={onClose}>
         <FHGTextField 
            name='diameter' 
            type='number' 
            autoFocus 
            label={'Diameter'}
            step='0.01'
            inputProps={{ 
               min: '0',
               step: '0.01'
            }}
            style={{ marginBottom: 8 }}
            onChange={handleDecimalChange}
            value={getValue('diameter') || ''} 
            required 
         />
      </ModalDialog>
   );
}
